<template>
    <div class="cabinet-table__row pt-4 pb-4">
        <div class="d-flex flex-column flex-md-row">
            <div class="dashboard-list__catalog">
                <div
                    class="dashboard-list__down d-flex align-items-center js-statistics"
                    @click="showCategoryTypes(category.CategoryID)"
                >
                    <div
                        :class="{ active: isCategoryTypes }"
                        class="dashboard-list__arrow"
                    ></div>
                    <div class="dashboard-list__cell-name">
                        {{ category.Name }}
                    </div>
                </div>
            </div>

            <div class="d-flex ml-4 ml-md-auto mt-2 mt-md-0">
                <div class="dashboard-list__value d-flex">
                    <div class="dashboard-list__value-icon">
                        <img src="/img/icons/eye.svg" alt="" />
                    </div>
                    <div class="dashboard-list__value-number">
                        {{ category.statistics.views }}
                    </div>
                </div>

                <div class="dashboard-list__value d-flex ml-3">
                    <div class="dashboard-list__value-icon">
                        <img src="/img/icons/star-2.svg" alt="" />
                    </div>
                    <div class="dashboard-list__value-number">
                        {{ category.statistics.list }}
                    </div>
                </div>

                <div class="dashboard-list__value d-flex ml-3">
                    <div class="dashboard-list__value-icon">
                        <img src="/img/icons/orders-2.svg" alt="" />
                    </div>
                    <div class="dashboard-list__value-number">
                        {{ category.statistics.shop }}
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="isCategoryTypes"
            class="dashboard-list__products ml-4 mt-4 js-statistics-content"
        >
            <p v-if="loadingCategoryTypes" class="m-0">Loading...</p>

            <template v-else>
                <div
                    v-for="(type, index) in categoryTypes"
                    :key="type.TypeID"
                    :class="{ 'mb-4': index !== categoryTypes.length - 1 }"
                    class="d-flex flex-column flex-md-row"
                >
                    <div class="dashboard-list__cell-name font-weight-normal">
                        {{ type.Name }}
                    </div>

                    <div class="d-flex ml-md-auto mt-2 mt-md-0">
                        <div class="dashboard-list__value d-flex">
                            <div class="dashboard-list__value-icon">
                                <img src="/img/icons/eye.svg" alt="" />
                            </div>
                            <div class="dashboard-list__value-number">
                                {{ type.statistics.views }}
                            </div>
                        </div>

                        <div class="dashboard-list__value d-flex ml-3">
                            <div class="dashboard-list__value-icon">
                                <img src="/img/icons/star-2.svg" alt="" />
                            </div>
                            <div class="dashboard-list__value-number">
                                {{ type.statistics.list }}
                            </div>
                        </div>

                        <div class="dashboard-list__value d-flex ml-3">
                            <div class="dashboard-list__value-icon">
                                <img src="/img/icons/orders-2.svg" alt="" />
                            </div>
                            <div class="dashboard-list__value-number">
                                {{ type.statistics.shop }}
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'CategoryCard',
    props: {
        category: {
            typeof: Object,
            required: true
        }
    },
    data() {
        return {
            loadingCategoryTypes: true,
            isCategoryTypes: false,
            categoryTypes: null
        }
    },
    computed: {
        ...mapGetters('supplierStats', ['categoryTypesStats'])
    },
    methods: {
        ...mapActions('supplierStats', ['getCategoryTypesStats']),
        async showCategoryTypes() {
            this.isCategoryTypes = !this.isCategoryTypes

            if (this.loadingCategoryTypes) {
                const payload = {
                    category_id: this.category.CategoryID
                }

                await this.getCategoryTypesStats(payload)

                this.categoryTypes = this.categoryTypesStats.types_views_statistics

                this.loadingCategoryTypes = false
            }
        }
    }
}
</script>
